module.exports = __webpack_public_path__ + "static/media/17UN-Women6.dfac9177.jpg";